module.exports = __webpack_public_path__ + "img/智慧环保.d698ffc0.png";